import React, { useState, useEffect } from 'react';
import { PageHeader } from 'antd';
import { getAccesTokenApi } from '../../../api/auth';
import { getSuppliersApi } from '../../../api/supplier';

import ListSuppliers from '../../../components/Admin/Suppliers/ListSuppliers';

export default function Suppliers() {
	const [reloadSuppliers, setReloadSuppliers] = useState(false);
	const [suppliers, setSuppliers] = useState([]);
	const token = getAccesTokenApi();

	useEffect(() => {
		getSuppliersApi(token).then((response) => {
			if (response.estado === 'OK') {
				setSuppliers(response.resultado);
			} else {
				setSuppliers([]);
			}
		});

		setReloadSuppliers(false);
	}, [token, reloadSuppliers]);

	return (
		<div>

			<PageHeader title="Proveedores" />
			<ListSuppliers suppliers={suppliers} reloadSuppliers={reloadSuppliers} />
		</div>
	);
}
